import { createContext, useState } from 'react';
import { ApiPaymentBalance, ApiAmountWithCurrency } from '../api';
import { IPointLoyalty } from '../utils/types';

export type BalancesItem = ApiPaymentBalance & {
  payment: ApiPaymentBalance['payment'] & {
    toPay: ApiAmountWithCurrency;
    received: ApiAmountWithCurrency;
    loyalty: IPointLoyalty;
  };
};

export type BalanceContextType = BalancesItem[];

export interface BalancesType {
  balances?: BalanceContextType;
  balancesSelection?: string[];
  setBalances: (balances?: BalanceContextType) => void;
  setBalancesSelection: (balancesSelection?: string[]) => void;
}

const initialBalanceState: BalancesType = {
  balances: undefined,
  balancesSelection: [],
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setBalances: (balances?: BalanceContextType) => {},
  setBalancesSelection: (
    balancesSelection?: string[],
    // eslint-disable-next-line @typescript-eslint/no-empty-function
  ) => {
    [];
  },
};

export const BalanceContext = createContext<BalancesType>(initialBalanceState);

export default function BalanceProvider({ children }: any) {
  const [balances, setBalances] = useState<BalanceContextType>();
  const [balancesSelection, setBalancesSelection] = useState<string[]>();

  return (
    <BalanceContext.Provider
      value={{
        balances,
        balancesSelection,
        setBalances,
        setBalancesSelection,
      }}
    >
      {children}
    </BalanceContext.Provider>
  );
}
